var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenu3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 42",
    opacity: 0.07,
    cx: 50,
    cy: 50,
    r: 50,
    fill: "#4D592B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.4153 25C65.1182 25.0003 65.813 25.1488 66.4546 25.4357C67.0962 25.7227 67.6701 26.1417 68.1388 26.6654C68.6076 27.1891 68.9606 27.8057 69.175 28.4751C69.3893 29.1444 69.4602 29.8514 69.3828 30.55L64.9403 70.55C64.8049 71.7734 64.223 72.9039 63.306 73.725C62.3889 74.5461 61.2013 75.0001 59.9703 75H39.4453C38.2144 75.0001 37.0267 74.5461 36.1097 73.725C35.1927 72.9039 34.6107 71.7734 34.4753 70.55L30.0303 30.55C29.953 29.8512 30.0239 29.144 30.2384 28.4745C30.4529 27.805 30.8062 27.1882 31.2752 26.6645C31.7442 26.1407 32.3184 25.7218 32.9603 25.435C33.6022 25.1482 34.2973 25 35.0003 25H64.4153ZM64.4153 30H35.0003L36.0628 39.5575C36.9604 39.3865 37.8682 39.2746 38.7803 39.2225C41.7778 39.0475 45.9203 39.4075 50.6928 41.4525C54.6703 43.1575 58.0278 43.4225 60.3428 43.285C61.2313 43.2378 62.1139 43.1123 62.9803 42.91L64.4153 30ZM62.4028 48.1C61.8728 48.175 61.2803 48.24 60.6353 48.275C57.6378 48.4525 53.4953 48.0925 48.7228 46.05C44.7453 44.3425 41.3878 44.0775 39.0728 44.215C38.2468 44.2605 37.4258 44.3726 36.6178 44.55L39.4453 70H59.9703L62.4028 48.1ZM47.2078 52.5C47.2078 53.163 46.9444 53.7989 46.4756 54.2678C46.0068 54.7366 45.3709 55 44.7078 55C44.0448 55 43.4089 54.7366 42.9401 54.2678C42.4712 53.7989 42.2078 53.163 42.2078 52.5C42.2078 51.837 42.4712 51.2011 42.9401 50.7322C43.4089 50.2634 44.0448 50 44.7078 50C45.3709 50 46.0068 50.2634 46.4756 50.7322C46.9444 51.2011 47.2078 51.837 47.2078 52.5ZM52.2078 62.5C52.8709 62.5 53.5068 62.2366 53.9756 61.7678C54.4444 61.2989 54.7078 60.663 54.7078 60C54.7078 59.337 54.4444 58.7011 53.9756 58.2322C53.5068 57.7634 52.8709 57.5 52.2078 57.5C51.5448 57.5 50.9089 57.7634 50.4401 58.2322C49.9712 58.7011 49.7078 59.337 49.7078 60C49.7078 60.663 49.9712 61.2989 50.4401 61.7678C50.9089 62.2366 51.5448 62.5 52.2078 62.5Z",
    fill: "#474747"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu3);
export default __webpack_public_path__ + "static/media/menu(3).058655208bfdbb34e34bf34bbd074075.svg";
export { ForwardRef as ReactComponent };